import reactIcon from '../../../assets/icons/react.svg';
import nextIcon from '../../../assets/icons/nextjs.svg';
import angularIcon from '../../../assets/icons/angular.svg';
import vueIcon from '../../../assets/icons/vue.svg';
import nodeIcon from '../../../assets/icons/nodejs.svg';
import expressIcon from '../../../assets/icons/express.svg';
import nestJsIcon from '../../../assets/icons/nestjs.svg';
import dockerIcon from '../../../assets/icons/docker.svg';

export const skills = {
	title: 'Skills',
	titleLevel: 'Level',
	list: [
		{
			id: 1,
			icon: reactIcon,
			link: 'https://pt-br.reactjs.org/',
			title: 'ReactJS',
			level: 'Advanced',
		},
		{
			id: 2,
			icon: reactIcon,
			link: 'https://reactnative.dev/',
			title: 'React Native',
			level: 'Intermediary',
		},
		{
			id: 3,
			icon: nextIcon,
			link: 'https://nextjs.org/',
			title: 'NextJS',
			level: 'Advanced',
		},
		{
			id: 4,
			icon: angularIcon,
			link: 'https://angular.io/',
			title: 'Angular',
			level: 'Basic',
		},
		{
			id: 5,
			icon: vueIcon,
			link: 'https://vuejs.org/',
			title: 'VueJS',
			level: 'Basic',
		},
		{
			id: 6,
			icon: nodeIcon,
			link: 'https://nodejs.org/en/',
			title: 'NodeJs',
			level: 'Intermediary',
		},
		{
			id: 7,
			icon: nestJsIcon,
			link: 'https://nestjs.com/',
			title: 'NestJs',
			level: 'Intermediary',
		},
		{
			id: 8,
			icon: expressIcon,
			link: 'https://expressjs.com/pt-br/',
			title: 'Express',
			level: 'Intermediary',
		},
		{
			id: 9,
			icon: dockerIcon,
			link: 'https://www.docker.com/',
			title: 'Docker',
			level: 'Basic',
		},
	],
};
